import type { SimpleBillingExpenseFilters, SimpleBillingInvoiceFilters, SimpleBillingPendingPaymentFilters } from "./types";

export const simpleBillingQueryKeys = {
  all: ["simple-billing"] as const,
  settings: ["simple-billing", "settings"] as const,
  receivablesSettings: ["simple-billing", "receivables-settings"] as const,
  products: (includeInactive: boolean) => ["simple-billing", "products", { includeInactive }] as const,
  product: (productId: string) => ["simple-billing", "product", productId] as const,
  rates: (productId: string) => ["simple-billing", "product", productId, "rates"] as const,
  measurementStatus: (tenantId: string | null = null) => ["simple-billing", "measurements", "status", tenantId] as const,
  productMeasurement: (productId: string) => ["simple-billing", "measurements", "product", productId] as const,
  comparativeEstimates: (tenantId: string | null = null) => ["simple-billing", "comparative-estimates", tenantId] as const,
  comparativeEstimate: (estimateId: string, tenantId: string | null = null) => ["simple-billing", "comparative-estimates", estimateId, tenantId] as const,
  invoice: (invoiceId: string, tenantId: string | null = null) => ["simple-billing", "invoice", invoiceId, tenantId] as const,
  invoicePayments: (invoiceId: string, tenantId: string | null = null) => ["simple-billing", "invoice", invoiceId, tenantId, "payments"] as const,
  invoices: ["simple-billing", "invoices"] as const,
  invoiceList: (filters: SimpleBillingInvoiceFilters, tenantId: string | null = null) => [
    "simple-billing",
    "invoices",
    { ...filters, tenantId },
  ] as const,
  pendingPayments: ["simple-billing", "pending-payments"] as const,
  pendingPaymentList: (filters: SimpleBillingPendingPaymentFilters, tenantId: string | null = null) => [
    "simple-billing",
    "pending-payments",
    { ...filters, tenantId },
  ] as const,
  salesSummary: ["simple-billing", "sales-summary"] as const,
  salesSummaryRange: (dateFrom: string, dateTo: string, tenantId: string | null = null) => [
    "simple-billing",
    "sales-summary",
    { date_from: dateFrom, date_to: dateTo, tenant_id: tenantId },
  ] as const,
  collectionsSummary: ["simple-billing", "collections-summary"] as const,
  collectionsSummaryRange: (dateFrom: string, dateTo: string, tenantId: string | null = null) => [
    "simple-billing",
    "collections-summary",
    { date_from: dateFrom, date_to: dateTo, tenant_id: tenantId },
  ] as const,
  businessSummary: ["simple-billing", "business-summary"] as const,
  businessSummaryRange: (dateFrom: string, dateTo: string, tenantId: string | null = null) => [
    "simple-billing",
    "business-summary",
    { date_from: dateFrom, date_to: dateTo, tenant_id: tenantId },
  ] as const,
  expenses: ["simple-billing", "expenses"] as const,
  inventory: ["simple-billing", "inventory"] as const,
  inventoryStatus: (tenantId: string | null = null) => ["simple-billing", "inventory", "status", tenantId] as const,
  inventoryPolicies: (tenantId: string | null = null) => ["simple-billing", "inventory", "policies", tenantId] as const,
  inventoryBalances: (tenantId: string | null = null) => ["simple-billing", "inventory", "balances", tenantId] as const,
  inventoryMovements: (tenantId: string | null = null) => ["simple-billing", "inventory", "movements", tenantId] as const,
  expenseList: (filters: SimpleBillingExpenseFilters, tenantId: string | null = null) => [
    "simple-billing",
    "expenses",
    { ...filters, tenantId },
  ] as const,
};
